/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getAllSizeRanges = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.SIZE_RANGES}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllSizeRanges:-', error);
    throw error;
  }
};

export const createSizeRange = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.SIZE_RANGES}`, data);
  } catch (error) {
    console.log('Error: SystemMaster-service: createSizeRange:-', error);
    throw error;
  }
};

export const updateSizeRange = async (sizeRangeId, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SIZE_RANGES}/${sizeRangeId}`, data);
  } catch (error) {
    console.log('Error: SystemMaster-service: updateSizeRange:-', error);
    throw error;
  }
};

export const deleteSizeRange = async (sizeRangeId, data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.SIZE_RANGES}/${sizeRangeId}`, { data });
  } catch (error) {
    console.log('Error: SystemMaster-service: deleteSizeRange:-', error);
    throw error;
  }
};

export const createSizeInRangeMaster = async (sizeRangeId, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.SIZE_RANGES}/${sizeRangeId}/sizes`, data);
  } catch (error) {
    console.log('Error: SystemMaster-service: createSizeInRange:-', error);
    throw error;
  }
};

export const updateSizeInRangeMaster = async (sizeRangeId, sizeId, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SIZE_RANGES}/${sizeRangeId}/sizes/${sizeId}`, data);
  } catch (error) {
    console.log('Error: SystemMaster-service: updateSizeInRange:-', error);
    throw error;
  }
};

export const deleteSizeInRangeMaster = async (sizeRangeId, sizeId, data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.SIZE_RANGES}/${sizeRangeId}/sizes/${sizeId}`, { data });
  } catch (error) {
    console.log('Error: SystemMaster-service: deleteSizeInRange:-', error);
    throw error;
  }
};

export const bulkSaveSizeRanges = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.BULK_SAVE_SIZE_RANGES}`, data);
  } catch (error) {
    console.log('Error: SystemMaster-service: bulkSaveSizeRanges:-', error);
    throw error;
  }
};
